import { createSelector } from '@ngrx/store';
import { creditCardsState } from '../root';

export const isPayByPointsSelected = createSelector(creditCardsState, (creditCards) => creditCards?.isPayByPointsSelected === true);
